import CircleIcon from "@mui/icons-material/Circle";
import { Box } from "@mui/material";

// @ts-ignore
import type { SearchMessageResult } from "@storyboard/web-client";
import ChannelDial from "@/components/Icons/ChannelDial";
import { prettyDate } from "@/components/Search/search";
import { sanitizeHtmlForDisplay } from "@/utils/sanitizeHtmlForDisplay";

export default function SearchItemHeader({ message }: { message: SearchMessageResult }) {
  return (
    <Box className="results-header">
      <Box>
        <ChannelDial height={13} width={16} />
      </Box>
      <Box
        dangerouslySetInnerHTML={{
          __html: sanitizeHtmlForDisplay(message.feedTitle ?? ""),
        }}
      />
      <Box className="circle-box">
        <CircleIcon />
      </Box>
      <Box
        dangerouslySetInnerHTML={{
          __html: sanitizeHtmlForDisplay(message.authorName ?? ""),
        }}
      />
      <Box className="circle-box">
        <CircleIcon />
      </Box>
      <Box>{prettyDate(message.publishDate)}</Box>
    </Box>
  );
}
